
































import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import QrCode from './QrCode.vue';
import ClipboardBar from './ClipboardBar.vue'
import { DictionaryEntry, DictionaryCategories } from '@/dictionary';

@Component({
    components: {
        QrCode,
        ClipboardBar
    }
})
export default class DictionaryCardComponent extends Vue {

    private snackbarOpen!: boolean;

    @Prop({ required: true })
    private word!: DictionaryEntry;

    @Prop({ default: true })
    private displayCategory!: boolean;

    @Ref()
    private clipboard!: ClipboardBar;

    @Ref()
    private audio!: HTMLAudioElement;

    private get categories() {
        return this.word.category.map(category => DictionaryCategories[category]);
    }

    private mouseUp(evt: MouseEvent) {
        evt.stopPropagation();
        evt.preventDefault();
        console.log('mouseUp');

        return true;
    }

    private async copy(evt: MouseEvent) {
        evt.stopPropagation();
        evt.preventDefault();

        await this.clipboard.copy(this.word.chinese);
    }

    private play(evt: MouseEvent) {
        evt.stopPropagation();
        evt.preventDefault();

        this.audio.play();
    }

    private data() {
        return {
            snackbarOpen: false
        }
    }


}
